import { Injector, Pipe, PipeTransform, Type } from "@angular/core";

interface PipeInjector {
  clazz: Type<unknown>;
  args: unknown[];
}

@Pipe({
  name: "pipes",
})
export class PipesInjectorPipe implements PipeTransform {
  constructor(private injector: Injector) {}

  transform(value: unknown, pipes: PipeInjector[]): any {
    if (!pipes?.length) {
      return value;
    }

    for (const pipe of pipes) {
      const { clazz, args } = pipe;

      const injector = Injector.create({
        name: "PipesInjectorPipe",
        parent: this.injector,
        providers: [{ provide: clazz }],
      });

      const pipeToInject = injector.get<{ transform: (value: any, ...arg: any[]) => unknown }>(clazz);

      try {
        if (args?.length) {
          value = pipeToInject.transform(value, ...args);
        } else {
          value = pipeToInject.transform(value);
        }
      } catch (err) {
        console.error(err);
      }
    }

    return value;
  }
}
